import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const Payment = () => {
  const [location, setLocation] = useState('');
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const passId = searchParams.get('passId');
  const checkoutId = searchParams.get('checkoutId');

  useEffect(() => {
    setLocation(`${window.location.protocol}//${window.location.host}/`);
  }, []);

  return (
    // <LandingLayout>
    // eslint-disable-next-line jsx-a11y/iframe-has-title, react/iframe-missing-sandbox
    <iframe
      width="100%"
      height={300}
      srcDoc={`<html>
  <head>
    <title>Title of the document</title>
  </head>
  <body>
    <form
      action=${location}paymentstatus?passId=${passId}
      class="paymentWidgets"
      data-brands="VISA MASTER AMEX"
    ></form>
    <script src=https://test.oppwa.com/v1/paymentWidgets.js?checkoutId=${checkoutId}></script>
  </body>
</html>`}
    />
    // </LandingLayout>
  );
};
export default Payment;
